import type { EditorFieldProps } from "./DefaultEditorFields";
import { DefaultEditorFields } from "./DefaultEditorFields";

export interface DefaultEditorFieldsListProps {
  fields: EditorFieldProps[];
}

export const DefaultEditorFieldsList = ({
  fields,
}: DefaultEditorFieldsListProps) => (
  <div className="flex flex-col gap-y-6 px-6 py-4">
    {fields.map(({ name, propMeta }) => (
      <DefaultEditorFields key={name} name={name} propMeta={propMeta} />
    ))}
  </div>
);
